import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HelpService } from '@ui-core/services/help.service'
import { ButtonModule } from 'primeng/button'
import { UseCaseInterface, UseCasesDataInterface } from './interfaces/use-case.interface'
import useCasesData from './use-cases.json'
import { UseCaseCard } from './components/use-case-card/use-case-card'

@Component({
    selector: 'app-help',
    imports: [CommonModule, ButtonModule, UseCaseCard],
    templateUrl: './help.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'fixed inset-0 z-[100]',
    },
})
export class Help {
    helpService = inject(HelpService)

    useCases = signal<UseCaseInterface[]>((useCasesData as UseCasesDataInterface).useCases)
}
